export const fonts = [
  { value: 'geist', label: 'Geist Sans' },
  { value: 'space', label: 'Space Grotesk' },
  { value: 'lora', label: 'Lora' },
  { value: 'instrument-italic', label: 'Instrument Serif Italic' },
] as const;